var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-button",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.28 27.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.58,27.26H4.72A4.38,4.38,0,0,1,.06,22.9q-.12-7.08,0-14.17a4.33,4.33,0,0,1,4.3-4.12c1.25,0,2.51,0,3.77,0A.94.94,0,0,0,9.2,4C10.31,1,12.46-.25,15.65,0A45,45,0,0,0,21,.06a4.38,4.38,0,0,1,4.49,2.8,2.41,2.41,0,0,0,2.95,1.76,14,14,0,0,1,2.05,0,4.39,4.39,0,0,1,4.77,4.58c.07,4.56.06,9.12,0,13.68a4.4,4.4,0,0,1-4.62,4.4Zm.08-3H30.44c1.35,0,1.91-.54,1.91-1.88q0-6.44,0-12.86c0-1.41-.56-1.95-2-2s-3,0-4.42,0a2,2,0,0,1-2.06-1.29c-.34-.75-.73-1.47-1.09-2.2A1.75,1.75,0,0,0,21,3q-3.43,0-6.88,0a1.77,1.77,0,0,0-1.79,1.14c-.35.77-.8,1.5-1.12,2.28a1.56,1.56,0,0,1-1.72,1c-1.53,0-3.06,0-4.59,0S3,8,3,9.43V22.37c0,1.49.45,1.93,2,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.18,15.17a7.56,7.56,0,0,1,7.3-7.71,7.69,7.69,0,0,1,.26,15.37A7.64,7.64,0,0,1,10.18,15.17Zm12.22,0a4.87,4.87,0,0,0-4.78-5,4.95,4.95,0,0,0,.08,9.89A4.88,4.88,0,0,0,22.4,15.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a8c5c0d9cdc373be5b12c90125ab4551.svg";
export { ForwardRef as ReactComponent };